import React from "react";
import "./index.css";
import { Link } from "react-router-dom";
import Button from "../../components/buttons/Buttons";
export default function NotFound() {
  return (
    <>
      <div className="w-full h-full hidden md:block">
        <div className="center">
          <div className="error">
            <div className="number">4</div>
            <div className="illustration">
              <div className="circle"></div>
              <div className="clip">
                <div className="paper">
                  <div className="face">
                    <div className="eyes">
                      <div className="eye eye-left"></div>
                      <div className="eye eye-right"></div>
                    </div>
                    <div className="rosyCheeks rosyCheeks-left"></div>
                    <div className="rosyCheeks rosyCheeks-right"></div>
                    <div className="mouth"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="number">4</div>
          </div>

          <div className="text">
            Oops. The page you're looking for doesn't exist.
          </div>

          <div className="w-[244px] h-16 mt-10">
            <Link to={"/"}>
              <Button
                title="go back home"
                bgColor="bg-[#FF6809]"
                textColor="text-white"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="md:hidden w-full h-full flex items-center justify-center flex-col ">
        <div className="text-6xl font-poppins font-bold">404</div>
        <div className="text">
          Oops. The page you're looking for doesn't exist.
        </div>
        <div className="w-[244px] h-16 mt-10">
          <Link to={"/"}>
            <Button
              title="go back home"
              bgColor="bg-[#FF6809]"
              textColor="text-white"
            />
          </Link>
        </div>
      </div>
    </>
  );
}
